import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
    variant?: 'light' | 'dark';
}

function LanguageSwitcher({ variant = 'dark' }: LanguageSwitcherProps) {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language?.startsWith('en') ? 'en' : 'fr';

    const handleChange = (_event: React.MouseEvent<HTMLElement>, value: string | null) => {
        if (value) {
            i18n.changeLanguage(value);
        }
    };

    const color = variant === 'light' ? 'rgba(255,255,255,0.85)' : undefined;
    const borderColor = variant === 'light' ? 'rgba(255,255,255,0.5)' : undefined;

    return (
        <ToggleButtonGroup
            value={currentLanguage}
            exclusive
            onChange={handleChange}
            size="small"
            aria-label={t('nav.language')}
            sx={{
                '& .MuiToggleButton-root': {
                    color,
                    borderColor,
                    px: 1.2,
                    py: 0.2,
                    fontSize: '0.75rem',
                },
                '& .Mui-selected': {
                    fontWeight: 700,
                },
            }}
        >
            <ToggleButton value="fr" aria-label="Français">
                FR
            </ToggleButton>
            <ToggleButton value="en" aria-label="English">
                EN
            </ToggleButton>
        </ToggleButtonGroup>
    );
}

export default LanguageSwitcher;
